import React, { useState } from "react";
import { Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { ModuleInputType, ModuleProxy } from "@me-team/host/main/graphql/types";
import Form from "react-bootstrap/Form";
import default_module_img from "@me-team/host/src/images/default_module_img.png";
import { useTranslation } from "react-i18next";
import styles from "../ModulesListStyles.module.scss";
import { ModulesTagName } from "../../../../../utils/enums";
import { useParams } from "react-router-dom";
import ViewLink from "../../ViewLink/ViewLink";

type OnlineBookingModuleProps = {
    modulesList: ModuleProxy[];
    updateModules: (companyId: number, updates: ModuleInputType[], branchId: number) => Promise<void>;
    isDisableMainModules: boolean;
    isLanguagesSubmitted: boolean;
    setIsLanguageModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    canManageModules: boolean;
};

const MenuModule: React.FC<OnlineBookingModuleProps> = (props) => {
    const { currentCompanyId, branchId } = useParams();
    const { t: translate } = useTranslation();
    const MENU_MODULE: ModuleProxy = props.modulesList.find(
        (module: ModuleProxy) => module.name === ModulesTagName.Menu
    );

    const basePath: string = process.env.REACT_APP_POS_URL;
    const imageSRC: string = MENU_MODULE.image
        ? `${basePath}/build/images/modules/${MENU_MODULE.image}`
        : default_module_img;
    const [isMainSwitchDisable, setIsMainSwitchDisable] = useState(false);

    const onToggleMenuHandler = async () => {
        if (!props.canManageModules) return;
        if (props.isLanguagesSubmitted) {
            setIsMainSwitchDisable(true);
            const updates: ModuleInputType[] = [{ id: MENU_MODULE.id, isActive: !MENU_MODULE.active }];
            await props.updateModules(Number(currentCompanyId), updates, Number(branchId));
            setIsMainSwitchDisable(false);
        } else {
            props.setIsLanguageModalOpen(true);
        }
    };

    return (
        <div className={"border rounded p-4 mt-4"}>
            <Row>
                <Col xl={2} xxl={2} className="mb-3 mb-xl-0">
                    <div className={!MENU_MODULE.active ? "opacity-75" : ""}>
                        <img className={`${styles.customImagesSize} d-block`} src={imageSRC} alt={MENU_MODULE.name} />
                    </div>
                </Col>
                <Col xl={5} xxl={6} className="mb-3 mb-xl-0 d-flex flex-column">
                    <div className={!MENU_MODULE.active ? "opacity-75" : ""}>
                        <h5 className={"fw-normal mb-2 fs-24"}>{translate(MENU_MODULE.name)}</h5>
                        <p className={"mb-0 text-grey"}>{MENU_MODULE.description}</p>
                        {MENU_MODULE.descriptionInfo && (
                            <p className={"mb-0 text-grey mt-2"}>
                                <i className="bi bi-info-circle me-2"></i>
                                {MENU_MODULE.descriptionInfo}
                            </p>
                        )}
                    </div>
                    <ViewLink
                        navigation={`/payment/company/${currentCompanyId}/modules/details/menu/branch/${branchId}`}
                    />
                </Col>
                <Col
                    xs={12}
                    sm={6}
                    md={6}
                    xl={2}
                    xxl={2}
                    className={"d-flex justify-content-start justify-content-sm-center d-xl-block mb-3 mb-sm-0"}
                ></Col>
                <Col
                    xs={12}
                    sm={6}
                    md={6}
                    xl={3}
                    xxl={2}
                    className={"d-flex flex-column justify-content-between align-items-center align-items-xl-end"}
                >
                    <Form className={"d-flex align-items-center"}>
                        <Form.Check
                            type="switch"
                            label={MENU_MODULE.active ? translate("Enabled") : translate("Disabled")}
                            checked={MENU_MODULE.active}
                            disabled={isMainSwitchDisable || props.isDisableMainModules}
                            className="mb-0 custom-module-switch fs-6"
                            onChange={onToggleMenuHandler}
                        />
                        <OverlayTrigger
                            placement="bottom"
                            overlay={
                                <Tooltip id={`tooltip-${MENU_MODULE.id}`}>
                                    {translate(
                                        "You can disable/enable the module functionality at any time without canceling your subscription."
                                    )}
                                </Tooltip>
                            }
                        >
                            <i className="bi bi-question-circle ms-2 text-grey cursor-pointer"></i>
                        </OverlayTrigger>
                    </Form>
                    <h5 className={"mt-3 mt-sm-0"}>{translate("Free")}</h5>
                </Col>
            </Row>
        </div>
    );
};

export default React.memo(MenuModule);
